<template>

  <div class="stock-slips">
     <KTCodePreview v-bind:title="'Danh sách phiếu xuất hàng lỗi'"
      > <template v-slot:toolbar
        >
        <div class="row">

          <div>
             <b-dropdown
              size="sm"
              id="dropdown-1"
              right
              > <template slot="button-content"
                > <i
                  style="font-size: 1rem"
                  class="fas fa-cog"
                ></i
                > <span class="font-weight-bolder">Thao tác</span> </template
              > <b-dropdown-item @click="reportClick"
                > <span
                  > <i
                    style="font-size: 1rem"
                    class="far fa-file-excel"
                  ></i
                  > &nbsp; Xuất Excel</span
                > </b-dropdown-item
              > </b-dropdown
            >
          </div>

          <div
            v-if="checkPermission(listPermission, 'STOCK_DEFECTIVE_EXPORT_INSERT')"
            class="ml-3"
          >
             <router-link to="/defective-goods-export/add-defective-goods-export"
              > <b-button
                v-bind:style="btnCreate"
                variant="primary"
                size="sm"
                class="font-weight-bolder"
                > <i
                  style="font-size: 1rem"
                  class="flaticon2-add-1"
                ></i
                >Thêm mới </b-button
              > </router-link
            >
          </div>

        </div>
         </template
      > <template v-slot:preview
        > <!-- Header session --> <b-row class="mb-5"
          > <b-col
            >
            <div class="d-flex justify-content-center align-items-center">
               <date-picker
                placeholder="Từ ngày"
                class="form-control-sm"
                :config="dpConfigs.start"
                v-model="dpForm.startDate"
              ></date-picker
              > <span class="ml-1 mr"></span> <date-picker
                placeholder="Đến ngày"
                class="form-control-sm"
                :config="dpConfigs.end"
                v-model="dpForm.endDate"
              ></date-picker
              >
            </div>
             </b-col
          > <b-col
            > <b-form-input
              v-model="searchId"
              type="text"
              placeholder="Mã phiếu"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input
            > </b-col
          > <b-col
            > <BDropdownCustom
              v-model="valueStore"
              :options="filterdOptionsStore"
              :placeholder="'cửa hàng'"
              :matchKey="['name']"
              :searchable="true"
            /> </b-col
          > <b-col
            > <Autosuggest
              :model="searchProduct"
              :suggestions="filteredOptionsProduct"
              placeholder="mã, tên, mã vạch sản phẩm"
              :limit="10"
              @select="onSelectedProduct"
              @change="onInputChangeProduct"
              suggestionName="productName"
            /> </b-col
          > <b-col
            > <b-form-select
              class="select-style"
              size="sm"
              v-model="selectedCompany"
              :options="listCompany"
              value-field="id"
              text-field="name"
              v-on:change="onChangeCompany"
              > <template v-slot:first
                > <b-form-select-option
                  :value="null"
                  disabled
                  >-- Doanh nghiệp --</b-form-select-option
                > </template
              > </b-form-select
            > </b-col
          > </b-row
        > <b-row class="mb-5"
          > <b-col
            > <BDropdownCustom
              v-model="valueReason"
              :options="filterdOptionsReason"
              :placeholder="'lý do'"
              :searchable="true"
              :matchKey="['name']"
            /> </b-col
          > <b-col></b-col> <b-col></b-col> <b-col></b-col> <b-col></b-col> </b-row
        > <b-row class="mb-5"
          > <b-col md="1"
            > <b-button
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              > Lọc </b-button
            > </b-col
          > <b-col md="auto"
            > <b-button
              variant="secondary"
              size="sm"
              @click="clearFilters"
              > <i class="fas fa-times mr-1"></i> Xóa bộ lọc </b-button
            > </b-col
          > </b-row
        > <!-- End of Header session --> <!-- Table session --> <b-table
          :items="stockSlips"
          :fields="fields"
          sort-by="count"
          class="table-bordered table-hover col-md-12"
          :busy="onLoading"
          > <template v-slot:table-busy
            > <vcl-table
              :speed="5"
              :animate="true"
              :columns="10"
            ></vcl-table
            > </template
          > <template v-slot:cell(count)="row"
            >
            <div style="text-align: center">
               <span
                v-text="row.item.count"
                class="text-right"
              ></span
              >
            </div>
             </template
          > <template v-slot:cell(code)="row"
            >
            <div class="inventory-receipt-code">
               <a
                class="code-link font-weight-bold"
                :href="getLinkDoc(row.item)"
                target="_blank"
                > {{ row.item.code }} </a
              >
              <div
                v-if="row.item.purchaseOrderCode"
                class="po-code"
              >
                 <span class="po-label">Mã PO:</span> <span class="po-value">{{
                  row.item.purchaseOrderCode
                }}</span
                >
              </div>

              <div
                v-if="row.item.vatSerial"
                class="vat-serial"
              >
                 <span class="vat-label">Số ký hiệu:</span> <span class="vat-value">{{
                  row.item.vatSerial
                }}</span
                >
              </div>

            </div>
             </template
          > <template v-slot:cell(sourceWarehouseId)="row"
            > <span
              v-text="row.item.sourceWarehouseId"
              class="font-weight-bolder"
            ></span
            > <br /> <span v-if="row.item.companyName">( {{ row.item.companyName }} )</span>
            </template
          > <template v-slot:cell(description)="row"
            >
            <div
              @mouseover="hoverDescription = true"
              @mouseleave="hoverDescription = false"
            >
               <span
                v-text="row.item.description"
                class="mr-2"
              ></span
              > <span @click="handleShowNoteModel(row.item)"
                > <i
                  v-if="hoverDescription"
                  class="fas fa-edit"
                ></i
                > </span
              >
            </div>
             </template
          > <template v-slot:cell(countProduct)="row"
            >
            <div style="text-align: right">
               <span
                v-text="convertPrice(row.item.countProduct)"
                class="text-right"
              ></span
              >
            </div>
             </template
          > <template v-slot:cell(countQuantity)="row"
            >
            <div style="text-align: right">
               <span
                v-text="convertPrice(row.item.countQuantity)"
                class="text-right"
              ></span
              >
            </div>
             </template
          > <template v-slot:cell(createBy)="row"
            > <RowCreatedByDate
              :createdBy="row.item.createBy"
              :createdAt="row.item.createdAt"
            /> </template
          > <template v-slot:cell(actions)="row"
            >
            <div class="d-flex justify-content-center">
               <b-dropdown
                size="sm"
                id="dropdown-left"
                no-caret
                right
                > <template slot="button-content"
                  > <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i
                  > </template
                > <b-dropdown-item @click="editItem(row.item)"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="flaticon2-pen"
                    ></i
                    > &nbsp; Chỉnh sửa </span
                  > </b-dropdown-item
                > <b-dropdown-item
                  @click="exportDefectiveDocument(row.item)"
                  :disabled="exportingDocumentId === row.item.id"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <b-spinner
                      v-if="exportingDocumentId === row.item.id"
                      small
                      class="mr-1"
                    ></b-spinner
                    > <i
                      v-else
                      style="font-size: 1rem"
                      class="far fa-file-excel"
                    ></i
                    > &nbsp; {{
                      exportingDocumentId === row.item.id
                        ? 'Đang xuất...'
                        : 'Xuất biên bản'
                    }} </span
                  > </b-dropdown-item
                > <b-dropdown-item
                  @click="showDeleteAlert(row.item)"
                  v-if="checkPermission(listPermission, 'STOCK_DEFECTIVE_EXPORT_DELETE')"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem; color: #d33"
                      class="flaticon2-rubbish-bin-delete-button"
                    ></i
                    > &nbsp; Xóa </span
                  > </b-dropdown-item
                > </b-dropdown
              >
            </div>
             </template
          > </b-table
        > <!-- End of Table session --> <!-- Paginate session --> <b-row
          > <b-col
            >
            <p
              class="mt-3 text-dark"
              style="font-weight: 500"
            >
               Tổng: {{ convertPrice(totalItems) }}
            </p>
             </b-col
          > <b-col
            > <b-pagination-nav
              v-model="page"
              class="custom-pagination"
              v-show="totalPages >= 2"
              :link-gen="linkGen"
              :number-of-pages="totalPages"
              use-router
              @change="fetchStockSlip"
              align="right"
              first-class="page-item-first btn btn-icon btn-sm m-1"
              prev-class="page-item-prev btn btn-icon btn-sm m-1"
              next-class="page-item-next btn btn-icon btn-sm m-1 "
              last-class="page-item-last btn btn-icon btn-sm m-1 "
              page-class="btn btn-icon btn-sm border-0 m-1"
              > <template v-slot:first-text
                > <span> <i class="ki ki-bold-double-arrow-back icon-xs"></i> </span> </template
              > <template v-slot:prev-text> <i class="ki ki-bold-arrow-back icon-xs"></i> </template
              > <template v-slot:next-text> <i class="ki ki-bold-arrow-next icon-xs"></i> </template
              > <template v-slot:last-text
                > <span class="text-info"
                  > <i class="ki ki-bold-double-arrow-next icon-xs"></i> </span
                > </template
              > </b-pagination-nav
            > </b-col
          > </b-row
        > <!-- End of Paginate session --> <template
          > <b-modal
            v-model="showEditPriceModal"
            hide-footer
            :title="'Sửa ghi chú cho phiếu: ' + stockSlipCode"
            > <b-row class="mb-5"
              > <b-col
                > <label
                  class="labelInput"
                  for="inputOriginalPrice"
                  >Ghi chú</label
                > <b-form-textarea
                  v-model="note"
                  placeholder="Nhập ghi chú..."
                  rows="5"
                  max-rows="6"
                ></b-form-textarea
                > </b-col
              > </b-row
            > <b-row
              > <b-col
                > <b-button
                  style="font-weight: 600; width: 70px"
                  variant="primary"
                  size="sm"
                  @click="updateNote"
                  >Lưu</b-button
                > <b-button
                  style="margin-left: 10px; font-weight: 600; width: 70px"
                  variant="secondary"
                  size="sm"
                  @click="handleShowNoteModel"
                  >Hủy</b-button
                > </b-col
              > </b-row
            > </b-modal
          > </template
        > </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import apiCommonMixin from '@/view/mixins/api-common.mixins.js'
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import ApiService from '@/core/services/api.service'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import moment from 'moment'
  import { DEFECTIVE_GOODS_EXPORT } from '@/utils/constants'
  import fileDownload from '@/utils/file-download'
  import { mapGetters } from 'vuex'
  import { VclTable } from 'vue-content-loading'
  import Swal from 'sweetalert2'
  import { checkPermission } from '@/utils/permission'
  import decounce from 'debounce'
  import axios from 'axios'
  import { BASE_URL } from '@/utils/constants'
  import { xoa_dau, convertPrice } from '@/utils/common'
  import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
  import cloneDeep from 'lodash/cloneDeep'
  import { getToastInstance } from '@/utils/toastHelper'
  import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue'
  import RowCreatedByDate from '@/view/components/common/RowCreatedByDate.vue'
  import { downloadDefectiveStockSlipDocument } from '@/utils/export-defective-stock-slip'

  export default {
    mixins: [apiCommonMixin],
    data() {
      return {
        dpForm: {
          startDate: moment().subtract(15, 'days').format('DD/MM/YYYY'),
          endDate: '',
        },
        dpConfigs: {
          start: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
          end: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
        },
        onLoading: false,
        exportingDocumentId: null,
        btnCreate: {
          fontWeight: '600!important',
        },
        stockSlips: [],
        searchDescription: '',
        searchStock: '',
        searchId: '',
        searchPO: '',
        searchVatSerial: '',
        currentPage: 0,
        totalPages: 1,
        count: 1,
        totalItems: 0,
        page: 1,
        stockSlipType: DEFECTIVE_GOODS_EXPORT,
        fields: [
          {
            key: 'count',
            label: 'STT',
            thStyle: {
              textAlign: 'center',
              fontWeight: 600,
              color: '#181c32',
              width: '4%',
            },
            tdClass: 'sttClass',
          },
          {
            key: 'code',
            label: 'Mã phiếu xuất kho',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '16%' },
          },
          {
            key: 'sourceWarehouseId',
            label: 'Kho',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          },
          {
            key: 'reasonName',
            label: 'Lý do',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          },
          {
            key: 'countProduct',
            label: 'SL SP',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          },
          {
            key: 'countQuantity',
            label: 'Tổng SL',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          },
          {
            key: 'description',
            label: 'Nội dung',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          },
          {
            key: 'createBy',
            label: 'Người tạo',
            sortable: false,
            thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          },
          { key: 'actions', label: '', thStyle: { width: '5%' } },
        ],
        limit: 10,
        searchProduct: '',
        filteredOptionsProduct: [],
        optionsProduct: [
          {
            data: [],
          },
        ],
        optionsStore: [
          {
            data: [],
          },
        ],
        selectedCompany: null,
        listCompany: [],
        valueStore: [],
        selectedType: null,
        hoverDescription: false,
        stockSlipCode: '',
        showEditPriceModal: false,
        note: '',
        optionsProvider: [],
        listProvider: [],
        filterdOptionsStore: [],
        filterdOptionsReason: [],
        valueReason: [],
        reasons: [],
      }
    },
    computed: {
      ...mapGetters(['listPermission']),
    },
    methods: {
      convertPrice,
      checkPermission,
      ...getToastInstance(),
      fetchStockSlip: async function () {
        this.onLoading = true
        this.page = this.$route.query.page
        if (!this.page) {
          this.page = 1
        }
        let listStoreId = []
        if (this.valueStore.length) {
          listStoreId = this.valueStore.map(({ code }) => code)
        }
        let listReasonId = []
        if (this.valueReason.length) {
          listReasonId = this.valueReason.map(({ id }) => id)
        }

        const params = {
          page: this.page,
          limit: 10,
          fromDate: this.dpForm.startDate
            ? moment(this.dpForm.startDate, 'DD/MM/YYYY').format('yyyy-MM-DD 00:00:00')
            : '',
          toDate: this.dpForm.endDate
            ? moment(this.dpForm.endDate, 'DD/MM/YYYY').format('yyyy-MM-DD 23:59:59')
            : '',
          type: this.stockSlipType,
          searchProduct: this.searchProduct,
          storeIds: listStoreId,
          companyId: this.selectedCompany,
          mode: this.selectedType,
          reasonIds: listReasonId,
        }

        ApiService.query('v1/stock-slips', { params })
          .then((response) => {
            this.stockSlips = []
            const stockResponse = response.data.data.data
            this.totalPages = response.data.data.totalPage
            this.currentPage = response.data.data.currentPage
            this.totalItems = response.data.data.totalRow
            let result = []
            stockResponse.forEach((item, index) => {
              let stock = {
                ...item,
                count: this.currentPage >= 2 ? index + 1 + this.currentPage * 10 - 10 : index + 1,
                createdAt: moment(item.createdAt).format('HH:mm:ss DD/MM/YYYY'),
              }
              result.push(stock)
              this.stockSlips = [...new Set(result)]
            })
            this.onLoading = false
          })
          .catch(() => {
            this.onLoading = true
          })
      },
      editItem: function (item) {
        this.$router.push({
          name: 'edit-defective-goods-export',
          query: { id: item.id },
        })
      },
      async exportDefectiveDocument(item) {
        if (!item?.id || this.exportingDocumentId) return

        this.exportingDocumentId = item.id
        try {
          await downloadDefectiveStockSlipDocument(item.id, item.code)
        } catch {
          this.makeToastFaile('Xuất biên bản thất bại, vui lòng thử lại.')
        } finally {
          this.exportingDocumentId = null
        }
      },
      showDeleteAlert: function (item) {
        Swal.fire({
          title: 'Xóa phiếu xuất kho lỗi!',
          text: 'Bạn có chắc muốn xóa phiếu xuất kho lỗi này không ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(221, 51, 51)',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: 'Xóa',
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          reverseButtons: true,
          position: 'top',
        }).then((result) => {
          if (result.value) {
            this.deleteItem(item)
          }
        })
      },
      deleteItem: async function (item) {
        ApiService.delete(`v1/stock-status-transfer/defective-stock-slips/${item.id}`).then(
          ({ data }) => {
            this.makeToastSuccess(data.message)
            this.fetchStockSlip()
          },
        )
      },
      fetchProduct() {
        this.optionsProduct[0].data = []
        ApiService.get(`products/searchProductByName?name=${this.searchProduct}`).then(
          ({ data }) => {
            const products = data.data
            products.map((element) => {
              this.optionsProduct[0].data.push(element)
            })
            this.filteredOptionsProduct = [...this.optionsProduct[0].data]
          },
        )
      },
      debounceInput: decounce(function () {
        this.fetchProduct()
      }, 500),
      onSelectedProduct(option) {
        this.searchProduct = option.item.productName
      },
      onInputChangeProduct(text) {
        if (!text) {
          text = ''
        }
        this.searchProduct = text
        this.debounceInput()
      },
      linkGen(pageNum) {
        const q = { ...this.$route.query }
        if (pageNum === 1) delete q.page
        else q.page = pageNum
        const s = Object.entries(q)
          .filter(([, v]) => v !== undefined && v !== null && v !== '')
          .map(([k, v]) =>
            Array.isArray(v)
              ? v.map((vv) => `${k}=${encodeURIComponent(vv)}`).join('&')
              : `${k}=${encodeURIComponent(v)}`,
          )
          .join('&')
        return s ? `?${s}` : '?'
      },
      buildQueryFromState() {
        const query = { page: 1 }
        if (this.dpForm.startDate) query.startDate = this.dpForm.startDate
        if (this.dpForm.endDate) query.endDate = this.dpForm.endDate
        if (this.searchId && this.searchId.trim()) query.searchId = this.searchId.trim()
        if (this.valueStore && this.valueStore.length)
          query.storeIds = this.valueStore.map(({ code }) => code)
        if (this.searchProduct && this.searchProduct.trim())
          query.searchProduct = this.searchProduct.trim()
        if (this.selectedCompany != null && this.selectedCompany !== '')
          query.companyId = this.selectedCompany
        if (this.valueReason && this.valueReason.length)
          query.reasonIds = this.valueReason.map(({ id }) => id)
        return query
      },
      restoreFiltersFromQuery() {
        const query = this.$route.query
        if (query.startDate) this.dpForm.startDate = query.startDate
        if (query.endDate) this.dpForm.endDate = query.endDate
        if (query.searchId) this.searchId = query.searchId
        if (query.searchProduct) this.searchProduct = query.searchProduct
        if (query.companyId !== undefined && query.companyId !== null && query.companyId !== '') {
          this.selectedCompany = Number(query.companyId)
        }
        const storeIds = query.storeIds
        if (storeIds && this.filterdOptionsStore.length) {
          const ids = Array.isArray(storeIds) ? storeIds : [storeIds]
          this.valueStore = ids
            .map((code) => {
              const opt = this.filterdOptionsStore.find((s) => String(s.code) === String(code))
              return opt ? { code: opt.code, name: opt.name, checked: true } : null
            })
            .filter(Boolean)
        }
        const reasonIds = query.reasonIds
        if (reasonIds && this.filterdOptionsReason.length) {
          const ids = Array.isArray(reasonIds) ? reasonIds : [reasonIds]
          this.valueReason = ids
            .map((id) => {
              const r = this.filterdOptionsReason.find((x) => String(x.id) === String(id))
              return r ? { id: r.id, name: r.name, checked: true } : null
            })
            .filter(Boolean)
        }
      },
      onFilter() {
        const query = this.buildQueryFromState()
        this.$router.push({ name: 'list-defective-goods-export', query })
        this.fetchStockSlip()
      },
      clearFilters() {
        this.dpForm.startDate = moment().subtract(15, 'days').format('DD/MM/YYYY')
        this.dpForm.endDate = ''
        this.searchId = ''
        this.valueStore = []
        this.searchProduct = ''
        this.selectedCompany = null
        this.valueReason = []
        this.$router.push({ name: 'list-defective-goods-export', query: { page: 1 } })
        this.fetchStockSlip()
      },
      fetchCompany: async function () {
        this.listCompany = []
        const response = await ApiService.get('/v1/companies/all')
        this.listCompany = response.data.data
        this.listCompany.unshift({
          id: null,
          name: 'Tất cả',
        })
      },
      onChangeCompany() {
        this.valueStore = []
        this.searchStock = ''
      },
      getLinkDoc(item) {
        return `#/defective-goods-export/edit-defective-goods-export?id=${item.id}`
      },
      reportClick: async function () {
        let listId = []
        if (this.valueStore.length) {
          listId = this.valueStore.map(({ code }) => code)
        }
        let listProviderId = []
        if (this.valueProviders.length) {
          listProviderId = this.valueProviders.map(({ code }) => code)
        }
        const searchDescription = this.searchDescription?.trim() || ''
        const searchCode = this.searchId?.trim() || ''
        const searchPO = this.searchPO?.trim() || ''
        const searchVatSerial = this.searchVatSerial?.trim() || ''
        const searchFromDay = this.dpForm.startDate
          ? moment(this.dpForm.startDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : ''
        const searchToDay = this.dpForm.endDate
          ? moment(this.dpForm.endDate, 'DD/MM/YYYY').format('yyyy-MM-DD')
          : ''
        const searchProduct = this.searchProduct
        const companyId = this.selectedCompany
        const typeSearch = this.selectedType
        const baseUrl = BASE_URL

        const url = `${baseUrl}v1/stock-slips/export-excel-stock-slip?type=${
          this.stockSlipType
        }&providerId=${
          this.selectedProvider
        }&searchProduct=${searchProduct}&searchDescription=${searchDescription}&searchCode=${searchCode}&searchPO=${searchPO}&searchVatSerial=${searchVatSerial}&searchFromDay=${searchFromDay}&searchToDay=${searchToDay}&companyId=${companyId}&typeSearch=${typeSearch}&${listId
          .map((n, index) => `storeIds[${index}]=${n}`)
          .concat(listProviderId.map((n, index) => `providerIds[${index}]=${n}`))
          .join('&')}`
        await axios({
          url: url,
          method: 'GET',
          responseType: 'blob',
          onDownloadProgress: function (progressEvent) {
            console.log(progressEvent)
          },
        }).then((response) => {
          const fileName = fileDownload.getFileName(response)
          fileDownload.createFile(response.data, fileName)
        })
      },
      handleShowNoteModel(item) {
        this.showEditPriceModal = !this.showEditPriceModal
        this.stockSlipCode = item.code
        this.note = item.description
      },
      updateNote() {
        const data = {
          stockSlipCode: this.stockSlipCode,
          description: this.note,
        }
        ApiService.put('v1/stock-slips/note', data)
          .then(({ data }) => {
            this.makeToastSuccess(data.message)
            this.showEditPriceModal = !this.showEditPriceModal
            this.fetchStockSlip()
          })
          .catch(({ response }) => {
            this.makeToastFaile(response.$error)
          })
      },
      onSelectedProvider(option) {
        this.searchProvider = option.item.name
        this.selectedProvider = option.item.id
      },
      onInputChangeProvider(text) {
        if (!text) {
          text = ''
        }
        this.searchProvider = text

        const filteredData = this.optionsProvider[0].data
          .filter((item) => {
            let itemName = xoa_dau(item.name)
            return itemName.toLowerCase().indexOf(text.toLowerCase()) > -1
          })
          .slice(0, this.limit)

        this.filteredOptionProvider = [...filteredData]
      },
      async fetchReason() {
        const response = await ApiService.get('v1/stock-status-transfer/defective-export-reasons')
        this.reasons = response.data.data
        this.filterdOptionsReason = [...this.reasons]
      },
      printItem: function (item) {
        this.$router.push({
          name: 'print-dispatch-invoice',
          query: { id: item.id },
        })
      },
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Xuất kho', route: 'inventory-dispatch' },
        { title: 'Danh sách phiếu xuất kho' },
      ])
    },
    async created() {
      const { stores, currentStoreId, currentStoreName } = await this.fetchStoreByUser()
      this.optionsStore = []
      stores.map((element) => {
        const option = {
          code: element.id,
          name: element.name,
          shortName: element.shortName,
          checked: false,
        }
        this.optionsStore.push(option)
      })
      this.filterdOptionsStore = cloneDeep(this.optionsStore)
      if (currentStoreId) {
        this.valueStore = [
          {
            code: currentStoreId,
            name: currentStoreName,
            checked: true,
          },
        ]
      }
      await Promise.all([this.fetchCompany(), this.fetchReason()])
      this.restoreFiltersFromQuery()
      this.fetchStockSlip()
    },
    components: {
      KTCodePreview,
      Autosuggest,
      VclTable,
      BDropdownCustom,
      RowCreatedByDate,
    },
  }
</script>

<style lang="scss">
  .stock-slips {

  .table th,
  .table td {
    padding: 0.25rem;
    vertical-align: middle;
    border-top: 1px solid #ecf0f3;
  }

  code,
  pre {
    margin: 1em 0;
    padding: 1em;
    border: 1px solid #bbb;
    display: block;
    background: #ddd;
    border-radius: 3px;
  }

  .form-group {
    margin-bottom: 1em;
  }

  .btn.btn-icon.btn-sm,
  .btn-group-sm>.btn.btn-icon {
    height: calc(1.35em + 1.1rem + 2px);
    width: auto;
  }

  .icon:hover {
    background-color: #90c6fc;
  }

  .sttClass {
    width: 20px;
  }

  ::-webkit-datetime-edit-year-field:not([aria-valuenow]),
  ::-webkit-datetime-edit-month-field:not([aria-valuenow]),
  ::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
    color: transparent;
  }

  .productCode:hover {
    text-decoration: underline;
  }

  .inventory-receipt-code {
    display: flex;
    flex-direction: column;
    gap: 4px;
    line-height: 1.4;

    .code-link {
      color: #000;
      text-decoration: none;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        color: #007bff;
        text-decoration: underline;
      }
    }

    .po-code {
      margin-top: 2px;
      line-height: 1.3;

      .po-label {
        font-size: 12px;
        color: #000;
      }

      .po-value {
        font-size: 12px;
        color: #5d9cec;
        margin-left: 4px;
      }
    }

    .vat-serial {
      margin-top: 2px;
      line-height: 1.3;

      .vat-label {
        font-size: 12px;
        color: #000;
      }

      .vat-value {
        font-size: 12px;
        color: #f6a623;
        margin-left: 4px;
      }
    }
  }

  .checkbox-label {
    display: block;
  }

  .page-item.disabled {
    cursor: not-allowed;

    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }
}
</style>

